module.exports = __webpack_public_path__ + "img/summit-3.2ccca984.jpg";